import { render } from "./AdminAppSections.vue?vue&type=template&id=2ae24290&scoped=true&ts=true"
import script from "./AdminAppSections.vue?vue&type=script&lang=ts"
export * from "./AdminAppSections.vue?vue&type=script&lang=ts"

import "./AdminAppSections.vue?vue&type=style&index=0&id=2ae24290&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ae24290"]])

export default __exports__